/* ============================================================
   Dathent — clarity.js (TASK-122, issue #214)
   Microsoft Clarity (session replay + heatmaps) loader — config-only, dark
   by default. There is no admin UI or server config for this yet, so the
   ONLY ways to turn it on are:
     1. localStorage.setItem('dathent.clarity.id', '<project-id>')  (one
        browser, for local/manual testing)
     2. VITE_CLARITY_ID at build time (an env-provided project id, for a
        real rollout once the owner creates the Clarity project)
   No id hardcoded anywhere in this file — without one of the above, this
   module injects nothing and is a complete no-op.

   Official snippet (docs.microsoft.com/clarity — "Install the tracking
   code") injected verbatim, just parameterized on the project id and moved
   into a function instead of an inline <script> tag.
   ============================================================ */

let injected = false;

function readClarityId() {
  try {
    const fromStorage = typeof window !== 'undefined' ? window.localStorage.getItem('dathent.clarity.id') : null;
    if (fromStorage && fromStorage.trim()) return fromStorage.trim();
  } catch (_) { /* storage unavailable — fall through to env */ }
  try {
    const fromEnv = import.meta && import.meta.env ? import.meta.env.VITE_CLARITY_ID : null;
    if (fromEnv && String(fromEnv).trim()) return String(fromEnv).trim();
  } catch (_) { /* no import.meta in this context */ }
  return null;
}

// Official Microsoft Clarity bootstrap snippet, unmodified apart from
// taking `id` as a parameter instead of a hardcoded literal.
function installClaritySnippet(id) {
  /* eslint-disable */
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', id);
  /* eslint-enable */
}

// Inject the Clarity tag if (and only if) a project id is configured.
// Safe to call multiple times — injects at most once per page load.
export function initClarity() {
  try {
    if (injected || typeof window === 'undefined' || typeof document === 'undefined') return;
    const id = readClarityId();
    if (!id) return; // dark by default — no id configured, do nothing
    injected = true;
    installClaritySnippet(id);
  } catch (_) { /* Clarity must never block boot */ }
}

export default initClarity;
